import React from 'react';
import './PolicyEcoanarchismDescription.css';

const PolicyEcoanarchismDescription = () => {
  const farm = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/farm.699e6dfc.png'}
    alt={'Ферма'}
    title={'Ферма'}
  />;

  const supply = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/supply.png'}
    alt={'Снабжение'}
    title={'Снабжение'}
  />;

  const unit = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-left'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />

  const emptyHex = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/cell.png'}
    alt={'Пустая ячейка'}
    title={'Пустая ячейка (без строений и ключевых точек)'}
  />;

  const speed = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/speed.png'}
    alt="Перемещение"
    title="Перемещение"
  />;

  return (
    <>
      <div className={'policy-description_line'}>
        От {farm} всегда можно
      </div>
      <div className={'policy-description_line'}>
        передать {supply} любому {unit}.
      </div>

      <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
        Пустые {emptyHex} не ограничивают {speed}.
      </div>
    </>
  );
};

export default PolicyEcoanarchismDescription;
